import React from 'react';
import './Projects.css';
import HuluScreen from '../../Images/hulu-screenshot.png';
import AirCnc from '../../Images/aircnc-screenshot.png';
import DoctorsPortal from '../../Images/doctors-screenshot.png';
import Restaurant from '../../Images/restaurant-screenshot.png';
import Power from '../../Images/power-screenshot.png';
import School from '../../Images/school-screetshot.png';
import Project from './Project';


const Projects = () => {

    const ProjectsInfo = [
        {
            'title': 'Hulu Clone', 
            'description': 'Its a fully responsive Hulu clone website.', 
            'img': HuluScreen,
            'githubLink': '/hulu-clone',
            'previewLink': 'https://hulu-clone-mdtaju.vercel.app/'
        },
        {
            'title': 'Air CNC', 
            'description': 'This is a house booking website. The website name is Air-CNC and this website is fully responsive.', 
            'img': AirCnc,
            'githubLink': '/air-cnc',
            'previewLink': 'https://taj-air-cnc.web.app/'
        },
        {
            'title': 'Doctors Portal', 
            'description': 'This is a Medical website. The website name is Doctors-Portal and this website is fully responsive.', 
            'img': DoctorsPortal,
            'githubLink': '/doctors-portal',
            'previewLink': 'https://taj-doctors-portal.web.app/'
        },
        {
            'title': 'Red Onion', 
            'description': 'This is a Restaurant website. The website name is Red-Onion and this website is fully responsive.', 
            'img': Restaurant,
            'githubLink': '/red-onion',
            'previewLink': 'https://red-onion-taj.web.app/'
        },
        {
            'title': 'Power-X', 
            'description': 'This is a gym website. The website name is Power-X and this website is fully responsive.', 
            'img': Power,
            'githubLink': '/power-x',
            'previewLink': 'https://taj-power-x.web.app/'
        },
        {
            'title': 'E-School', 
            'description': 'This is a school website to learn online. Its a modern website. This website is fully responsive.', 
            'img': School,
            'githubLink': '/e-school',
            'previewLink': 'https://mdtaju.github.io/e-school/'
        }
    ]

    return (
        <section className='projects' id='projects'>
            <h1 className='title' data-aos="zoom-in">Projects</h1>
            <div className="container cards_">
                {
                    ProjectsInfo.map(Item => (
                        <Project key={Item.title} title={Item.title} description={Item.description} image={Item.img} github={Item.githubLink} preview={Item.previewLink}/>
                    ))
                }
            </div>
        </section>
    );
};

export default Projects;